import React from 'react';

import { RCIcon } from '@reverbdotcom/cadence/components';
import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';
import {
  XCircleIcon,
  SmileyIcon,
  LightningIcon,
  TipJarIcon,
} from '@phosphor-icons/react';

import { Paths } from '../../../components/shared/url_helpers';

interface IProps {
  onDismiss: (event: any) => void;
}

export default function WalletMarketingCallout({ onDismiss }: IProps) {

  function handleOnClick() {
    window.location.href = Paths.shopPoliciesEdit.expand({});
  }

  function handleOnKeyDown(event: React.KeyboardEvent) {
    if (event.key === 'Enter') {
      handleOnClick();
    }
  }

  return (
    <div
      className="earnings-payouts__marketing-call-out"
      onClick={() => handleOnClick()}
      onKeyDown={(e) => handleOnKeyDown(e)}
      role="button"
      tabIndex={0}
    >
      <div
        className="earnings-payouts__marketing-call-out__dismiss"
        onClick={onDismiss}
        onKeyDown={(e) => e.key === 'Enter' && onDismiss(e)}
        role="button"
        tabIndex={0}
      >
        <RCIcon icon={<XCircleIcon weight="fill" />} size="5" />
      </div>
      <div className="earnings-payouts__marketing-call-out__content">
        <div className="mr-2">
          <Translate
            html
            text="earnings.payouts.walletMarketing.content_html"
            args={{
              break: '<br/>',
              strongOpen: '<strong>',
              strongClose: '</strong>',
            }}
          />
        </div>
        <div className="earnings-payouts__marketing-call-out__icons--outer">
          <div className="earnings-payouts__marketing-call-out__icons--inner">
            <RCIcon icon={<LightningIcon weight="duotone" />} size="7" />
            <RCIcon icon={<TipJarIcon weight="duotone" />} size="7" />
            <RCIcon icon={<SmileyIcon weight="duotone" />} size="7" />
          </div>
        </div>
      </div>
    </div>
  );
}
